/**
 * Created by mauget on 9/8/16.
 */


// BaseGraphicsPageView.js

import _ from 'lodash';
import { View } from 'backbone';
import listService      from 'ListService';
import eventBus         from 'EventBus.js';
import ConnectionTracker from 'ConnectionTracker';
import behaviorHelperService    from 'BehaviorHelperService.js';
import constants       from 'Constants.js';
class BaseGraphicsPageView extends View {

    //==========================================================================
    // Init sticky connection support.
    //==========================================================================
    supportStickyConnections( fcanvas ) {

        //------------------------------------------------
        // Track tricky sticky connection rendering
        //------------------------------------------------
        fcanvas.off('object:moving');
        fcanvas.on('object:moving', evt =>  ConnectionTracker.trackConnections( evt ) );
    }


    updateConnectionLineOnObject(line, connection) {

        const fcanvas = listService.fcanvas;

        line.srcId = line.model.get('srcWidgetModel').attributes.id;
        line.destId = line.model.get('destWidgetModel').attributes.id;

        const srcWidget = _( fcanvas.getObjects() )
            .filter( w => w.model && w.model.get('id') === line.srcId )
            .first();

        const destWidget = _( fcanvas.getObjects() )
            .filter( w => w.model && w.model.get('id') === line.destId )
            .first();

        // Check for existence, may not be there if we are on another tab (ie workflow or Layout)
        if (srcWidget) {
            _.forEach(srcWidget.connection, function (c) {
                if (c.line.model.get('id') === line.model.get('id')) {
                    c.line = line;
                }
            });
        }

        if (destWidget) {
            _.forEach(destWidget.connection, function (c) {
                if (c.line.model.get('id') === line.model.get('id')) {
                    c.line = line;
                }
            });
        }

        connection.line = line;
    }

    checkObjectLocation(fcanvas, top, left, model, group, selectedFabric) {
        // check if out of bounds
        let _left, _top;
        if (!group){
           _left = left < 0 ? Number(fcanvas.width) + (left * -1) : left;
           _top = top < 0 ? Number(fcanvas.height) + (top * -1) : top;
        }else{
            _left = group.left < 0 ? Number(fcanvas.width) + (group.left * -1) : group.left;
            _top = group.top < 0 ? Number(fcanvas.height) + (group.top * -1) : group.top;
        }

        const canvasRawId = 'aPageSel';
        const rightEdge = !group ? Number(model.get('width')) + Number(_left) : group.width + Number(_left);
        const bottomEdge = !group ? Number(model.get('height')) + Number(_top) : group.height + Number(_top);
        const buffer = 5;
        let drewNewWidth = false;
        if ( rightEdge+buffer > (fcanvas.width)) {
            const newWidth = rightEdge+buffer;
            if (listService.mainKind === 'B') {
                behaviorHelperService.showBehaviorInstance(listService._currentBehaviorInstanceId, newWidth, fcanvas.height );
                drewNewWidth = true;
                window.setTimeout(() => {
                    this.selectFabricObject(fcanvas, selectedFabric, group);
                }, 0);
            }
           
            if (listService.mainKind === 'W') {
                fcanvas.clear();
                eventBus.trigger('resizeWorkflowCanvas', canvasRawId, newWidth, fcanvas.height);
                eventBus.trigger('redrawWorkflowGrid');
                listService.getMainView( constants.KIND_WORKFLOW ).renderWorkflowObjects();                
                this.selectFabricObject(fcanvas, selectedFabric, group);
            }
        
          }
        if (bottomEdge+buffer > (fcanvas.height)) {
            const newHeight = bottomEdge+buffer;

            if (listService.mainKind === 'B' && !drewNewWidth) {
                behaviorHelperService.showBehaviorInstance(listService._currentBehaviorInstanceId, fcanvas.width, newHeight );
                window.setTimeout(() => {
                    this.selectFabricObject(fcanvas, selectedFabric, group);
                }, 0);
            }

            if (listService.mainKind === 'W') {
                fcanvas.clear();
                eventBus.trigger('resizeWorkflowCanvas', canvasRawId, fcanvas.width, newHeight);
                eventBus.trigger('redrawWorkflowGrid');
                listService.getMainView( constants.KIND_WORKFLOW ).renderWorkflowObjects();                
                this.selectFabricObject(fcanvas, selectedFabric, group);
            }
         }

     }
    

    selectFabricObject(fcanvas, selectedFabric, group){
        let objFabric;
        if (!group){
            objFabric = listService.getCanvasObjectById(selectedFabric.model.id);
            fcanvas.remove(objFabric);
            fcanvas.add(objFabric);
            fcanvas.setActiveObject(objFabric);
         }else{
             const group = new fabric.Group();
             group.canvas = fcanvas;
             _.forEachRight(selectedFabric.objects, obj => {
                 objFabric = listService.getCanvasObjectById(obj.model.id);                        
                 group.addWithUpdate(objFabric);
             });
             fcanvas.add(group);
             fcanvas.setActiveGroup(group);
             fcanvas.renderAll();
             fcanvas.remove(group);
         }
    }

    // PF-3561 Evict any connections from active group -- they'll follow their dragged anchor points
    // Also evict a single selected connection
    evictConnectionsFromMultiSelection(fcanvas) {
        const
            activeGroup = fcanvas.getActiveGroup(),
            activeObject = fcanvas.getActiveObject();
        if (activeGroup) {
            // We must modify in descending order or the remove interferes with fabricjs's group logic.
            _.forEachRight(activeGroup._objects, obj => {
                if (obj.model && obj.model.get('factoryKey') === 'connection_arrow') {
                       activeGroup.removeWithUpdate(obj);
                   }           
            });
            fcanvas.renderAll();

        }

        // PF-3625 -- foliowing code added in PF-3561 caused regression of functionality added in PF-2068:
        /*else if (activeObject && activeObject.model && activeObject.model.get('factoryKey') === 'connection_arrow' ) {
            fcanvas.deactivateAll().renderAll();
            // fcanvas.discardActiveObject().renderAll();
        }*/
    }

}

export default BaseGraphicsPageView;
